import { useEffect, useState } from "react";
import DatePicker from "../../../common/DatePicker";
import Filters from "../../../common/Filters/Filters";
import SearchBoxWithCustomQuery from "../../../common/SearchBoxWithCustomQuery";
import Table from "../../../common/Table/Table";
import { formatDate } from "../../../helpers/functions/dateFormatter";
import ActionButton from "../common/ActionButton";
import useInvoiceList from "../hooks/useInvoiceList";
import CreateInvoice from "./CreateInvoice";

// Import xlsx library for Excel export


const InvoiceList = () => {


    const [showModal, setShowModal] = useState(false);

    const [searchOrDate, setSearchOrDate] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);


    const handleDownload = (data) => {
        const { invoice_url, invoice_number } = data
        var link = document.createElement('a');
        link.href = invoice_url;
        link.download = invoice_number;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    // Function to export filtered data to Excel
 

    const columns = [
        {
            title: "#",
            data_key: "",
            render: (row, index) => {
                return <>{index + 1}</>;
            },
        },
        {
            title: "Name",
            data_key: "name",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.name}</span>{" "}

                    </>
                );
            },
        },
        {
            title: "Phone",
            data_key: "phone",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.phone}</span>{" "}

                    </>
                );
            },
        },
        {
            title: "State",
            data_key: "state",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.state}</span>{" "}

                    </>
                );
            },
        },
        {
            title: "Invoice Number",
            data_key: "invoice_number",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.invoice_number}</span>{" "}

                    </>
                );
            },

        },
        {
            title: "Invoice Date",
            data_key: "invoice_date",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.invoice_date}</span>{" "}

                    </>
                );
            },

        },
        // {
        //     title: "Due Date",
        //     data_key: "due_date",
        //     sortable: false,
        //     render: (row) => {
        //         return (
        //             <>
        //                 <span className=" text-nowrap">{row?.due_date}</span>{" "}

        //             </>
        //         );
        //     },
        // },
        {
            title: "Total Amount",
            data_key: "total_amount",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.total_amount}</span>{" "}

                    </>
                );
            },
        },
        {
            title: "Taxable Amount",
            data_key: "taxable_amount",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <span className=" text-nowrap">{row?.taxable_amount.toFixed(2)}</span>{" "}

                    </>
                );
            },
        },
        // {
        //     title: "CGST",
        //     data_key: "cgst",
        //     sortable: false,
        //     render: (row) => {
        //         return (
        //             <>
        //                 <span className=" text-nowrap">{row?.cgst}</span>{" "}

        //             </>
        //         );
        //     },
        // },
        // {
        //     title: "SGST",
        //     data_key: "sgst",
        //     sortable: false,
        //     render: (row) => {
        //         return (
        //             <>
        //                 <span className=" text-nowrap">{row?.sgst}</span>{" "}

        //             </>
        //         );
        //     },

        // },
        // {
        //     title: "IGST",
        //     data_key: "igst",
        //     sortable: false,
        //     render: (row) => {
        //         return (
        //             <>
        //                 <span className=" text-nowrap">{row?.igst}</span>{" "}

        //             </>
        //         );
        //     },
        // },
        {
            title: "Description",
            data_key: "description",
            sortable: false,
            render: (row) => {
                const description = row?.line_items && row?.line_items.length > 0 ? row?.line_items[0].description : "";
                return (
                    <>
                        <span >{description}</span>{" "}
                    </>
                );
            },
        },

        {
            title: "Action",
            data_key: "",
            sortable: false,
            render: (row) => {
                return (
                    <>
                        <div className="d-flex align-items-center gap-1">


                            <button
                                className=" btn btn-danger btn-sm text-sm text-nowrap"
                                onClick={() => { handleDelete(row?.invoice_id) }}
                            >
                                {" "}
                                <i className="bi bi-trash"></i>
                            </button>



                            <button
                                className=" btn btn-outline-light btn-sm text-sm text-nowrap"
                                style={{ backgroundColor: "rgb(255, 255, 255)", color: "rgb(33, 150, 243)" }}
                                onClick={() => {
                                    handleDownload(row)

                                }}
                            >

                                <i class="bi bi-download"></i>
                            </button>
                        </div>
                    </>
                );
            },


        },

    ];




    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    const { data, filterData, setFilterData, handleDelete, loading, startDate, endDate, handleGetData, setStartDate, setEndDate, filtersList, resetDateFilters, exportToExcel, setFetchData } = useInvoiceList();
    console.log({ showModal, filterData })
    return (
        <>

            {showModal && (
                <CreateInvoice
                    fullscreen={true}
                    show={showModal}
                    onHide={() => {
                        setShowModal(false);
                    }}
                />
            )}


            <div className="container background-white mt-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex justify-content-between align-items-center mb-1" style={{
                        width: screenWidth <= 321 ? "296px" :
                            screenWidth <= 376 ? "352px" :
                                screenWidth <= 426 ? "402px" :
                                    "250px",
                        minWidth: "100px"
                    }}>
                        <h5 className="mb-0 me-2">Invoices</h5>

                    </div>


                    <div className="d-flex align-items-end ms-auto gap-1 flex-wrap " >
                        {searchOrDate === "date" && (
                            <div className="d-flex align-items-end gap-1 position-relative">
                                <div className="col-auto position-relative" style={{
                                    width: screenWidth <= 321 ? "125px" :
                                        screenWidth <= 376 ? "153px" :
                                            screenWidth <= 426 ? "178px" :
                                                "120px",
                                    minWidth: "100px"
                                }}>
                                    <DatePicker
                                        date={startDate}
                                        id="start_date"
                                        name="start_date"
                                        placeholder="Start Date"
                                        label="Start Date"
                                        labelStyle={{ fontSize: "12px" }}
                                        inputStyle={{
                                            fontSize: "12px",
                                            width: "100%"
                                        }}
                                        isRequired={false}
                                        setDate={(e) => setStartDate(e)}
                                    />
                                </div>
                                <div className="col-auto position-relative" style={{
                                    width: screenWidth <= 321 ? "125px" :
                                        screenWidth <= 376 ? "153px" :
                                            screenWidth <= 426 ? "178px" :
                                                "120px",
                                    minWidth: "100px"
                                }}>
                                    <DatePicker
                                        date={endDate}
                                        id="end_date"
                                        name="end_date"
                                        placeholder="End Date"
                                        label="End Date"
                                        labelStyle={{ fontSize: "12px" }}
                                        inputStyle={{ fontSize: "12px", width: "100%" }}
                                        isRequired={false}
                                        maxDate={formatDate(new Date(), "yyyy-mm-dd")}
                                        setDate={(e) => setEndDate(e)}
                                    />
                                </div>
                                <button
                                    className="btn btn-outline-secondary btn-sm"
                                    disabled={loading}
                                    onClick={() => handleGetData(startDate, endDate)}
                                >
                                    Go
                                </button>
                            </div>
                        )}

                        {searchOrDate === "search" && (
                            <SearchBoxWithCustomQuery
                                allData={data}
                                setFilteredData={setFilterData}
                                placeholder="Search..."
                                return_array={true}
                                keysToSearchOn={["reference_no", "uid", "financier_name","phone", "name","state", "invoice_number"]}
                                useSearchBoxButton={false}
                            />
                        )}

                        {/* Action Buttons */}
                        <div className="d-flex gap-1 ms-auto">
                            <ActionButton
                                active={searchOrDate === "search"}
                                icon="bi-search"
                                onClick={() =>
                                    setSearchOrDate((prev) => (prev === "search" ? "" : "search"))
                                }
                            />
                            <ActionButton
                                active={searchOrDate === "date"}
                                icon="bi-calendar4"
                                onClick={() =>
                                    setSearchOrDate((prev) => (prev === "date" ? "" : "date"))
                                }
                            />

                          

                            <Filters
                                data={data}
                                setData={setFilterData}
                                filteredData={filterData}
                                setFilteredData={setFilterData}
                                filtersList={filtersList}
                            />
                            <ActionButton
                                active={searchOrDate === "new"}

                                icon="bi bi-plus-lg"
                                onClick={() => setShowModal(true)}

                                disabled={loading}
                            />

                            <ActionButton
                                active={searchOrDate === "download"}

                                icon="bi bi-download"
                                onClick={() => exportToExcel(filterData)}

                                disabled={loading || filterData.length === 0}
                                title={filterData.length === 0 ? "No data to export" : "Download Excel"}
                            />

                            <ActionButton
                                active={searchOrDate === "reload"}

                                icon="bi bi-arrow-clockwise"
                                onClick={() => handleGetData(startDate, endDate)}

                                disabled={loading || filterData.length === 0}
                                title={filterData.length === 0 ? "No data to export" : "Download Excel"}
                            />

                        </div>
                    </div>
                </div>
                <div
                    className="table-responsive mt-2 tmDashContainers"
                    style={{ minHeight: "5rem", maxHeight: "50rem", maxWidth: "100%" }}
                >

                    <Table data={filterData}
                        columns={columns}
                        loading={loading}
                        loading_rows={5}
                        loading_cols={11}
                        no_data_msg="No Data Found"
                        td_text_position="start"
                        th_text_position="start"
                        tfoot={null}
                    />

                </div>
            </div>



        </>
    )
};


export default InvoiceList;
